﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcChartAnimation from '@mescius/wijmo.chart.animation';
var WjFlexChartAnimationBehavior = /** @class */ (function (_super) {
    __extends(WjFlexChartAnimationBehavior, _super);
    function WjFlexChartAnimationBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexChartAnimationBehavior.tag = 'wj-flex-chart-animation';
    WjFlexChartAnimationBehavior.parentInCtor = true;
    WjFlexChartAnimationBehavior.props = [
        'animationMode',
        'easing',
        'duration',
        'axisAnimation'
    ];
    WjFlexChartAnimationBehavior.events = [
        'initialized'
    ];
    WjFlexChartAnimationBehavior.classCtor = function () { return wjcChartAnimation.ChartAnimation; };
    return WjFlexChartAnimationBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.chart.animation.ChartAnimation} class.
 *
 * The <b>wj-flex-chart-animation</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.chart.WjFlexChart}
 * , {@link wijmo.vue2.chart.WjFlexPie}
 * , {@link wijmo.vue2.chart.finance.WjFinancialChart}
 *  or {@link wijmo.vue2.chart.radar.WjFlexRadar}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.chart.animation.ChartAnimation} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexChartAnimation = WjFlexChartAnimationBehavior.register();
function registerV3WjFlexChartAnimation(app) {
    app.component(WjFlexChartAnimationBehavior.tag, WjFlexChartAnimation);
}
export function registerChartAnimation(app) {
    if (VueApi.isV3Plus) {
        registerV3WjFlexChartAnimation(app);
    }
}
